module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_21.51f48a43.jpg";